import { render, staticRenderFns } from "./Orgs.vue?vue&type=template&id=3ca030b3&scoped=true&"
import script from "./Orgs.vue?vue&type=script&lang=js&"
export * from "./Orgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca030b3",
  null
  
)

export default component.exports